import { requests } from "../../../api/agent"

export default {
	create                : (params) => requests.post('/ReMechanism/create', params),
	update                : (params) => requests.post('/ReMechanism/update', params),
	delete                : (params) => requests.getWithParams('/ReMechanism/delete', params),
	restore               : (params) => requests.getWithParams('/ReMechanism/restore', params),
	getPaged              : (params) => requests.getWithParams('/ReMechanism/getPaged', params),
	getPagedAll           : (params) => requests.getWithParams('/ReMechanism/getPagedAll', params),
	getPagedAudit         : (params) => requests.getWithParams('/ReMechanism/getPagedAudit', params),
	getList               : (params) => requests.getWithParams('/ReMechanism/getList', params),
}